export const downloadText = (code, name) => {
  const downloadElement = document.createElement('a');
  downloadElement.setAttribute(
    'href',
    'data:text/plain;charset=utf-8,' + encodeURIComponent(code)
  );
  downloadElement.setAttribute('download', name);
  downloadElement.click();
};

export const downloadSVGtoPNG = (svg, filename) => {
  const img = document.createElement('img');
  img.onload = function () {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.width = img.width;
    canvas.height = img.height;
    context.drawImage(img, 0, 0);
    const canvasData = canvas.toDataURL('image/png');
    const png = document.createElement('img');
    png.onload = function () {
      const a = document.createElement('a');
      a.download = filename + '.png';
      a.href = png.getAttribute('src');
      a.click();
    };
    png.setAttribute('src', canvasData);
  };

  img.setAttribute(
    'src',
    'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)))
  );
};
